import React, { useState } from 'react'
//import './flex.scss'
import { Flex, FlexCard, PanelButton, FileInput, Button } from 'bootflex'
import { FaEye, FaPlus, FaSearch, FaSync } from 'react-icons/fa'

const CardDemo = () => {
  // eslint-disable-next-line
  const [eyeActive, setEyeActive] = useState(false)
  const [searchActive, setSearchActive] = useState(true)
  const [plusActive, setPlusActive] = useState(false)
  return (
    <>
      <FlexCard noborder variant='fixed'>
        <FlexCard.Header bg='flex-gradient-sunny-morning text-dark' className='p-2'>
          <Flex.Item order='1'>
            <h4>CARD WITH PANEL BUTTONS</h4>
          </Flex.Item>
          <Flex.Item order='3' className='d-flex align-items-center justify-content-end'>
            <PanelButton onClick={() => setEyeActive(!eyeActive)} active={eyeActive}>
              <FaEye size='1.25em' />
            </PanelButton>
            <PanelButton onClick={() => setSearchActive(!searchActive)} active={searchActive}>
              <FaSearch size='1em' />
            </PanelButton>
            <PanelButton onClick={() => setPlusActive(!plusActive)} active={plusActive}>
              <FaPlus size='1.25em' />
            </PanelButton>
          </Flex.Item>
        </FlexCard.Header>
        <FlexCard.Body>
          This card has panel buttons
          <FileInput id='test' content='xxx' />
          <div className='p-2'>
            HERE ARE SOME COMPACT BUTTONS
            <Button minimal color='green' onClick={() => console.log('Button Clicked')}>
              <FaSync />
            </Button>
          </div>
        </FlexCard.Body>

        <FlexCard.Footer>
          <Flex.Item order='1' align='center' content='THIS IS MY FOOTER (CENTER ALIGNED)' />
        </FlexCard.Footer>
      </FlexCard>
    </>
  )
}

export default CardDemo
